import * as React from 'react';
import { useState } from "react";
import { login } from '../api/authClientApi';
import { getMaybeActiveUserOrRefresh } from '../api/serverApiHelpers';
import { CorePageWrapper } from '../designSystem/layouts/pageWrappers/CorePageWrapper';
import { MessageCard } from '../designSystem/Message';
import { Button } from '../designSystem/button/Button';
import { ButtonRow } from '../designSystem/button/ButtonRow';
import { TextField } from '../designSystem/formField/text/TextField';
import { Flex } from '../designSystem/compositeComponents/FlexHelpers';
import { P } from '../designSystem/typography/Body';
import { useParams } from 'react-router-dom';
import { AmorgBrand, CardLogin, CardLoginWrapper, LoginLayout, LoginText, SpecialHeaderWrapper } from '../designSystem/layouts/LayoutLogin';
import { Label } from '../designSystem/Label';
import { rawColors } from '../designSystem/colors/color';
import { Link } from '../designSystem/Link';

import { forgiveWhitespaceAndCase } from '../amorg-common';
import { appUrlBuilder } from '../utils/appUrlBuilder';

export default function LoginPage(): JSX.Element {

    function getRandomImageAndText() {
        const index = Math.floor(Math.random() * imageSet.length);
        return imageSet[index];
    }
    
    const imageSet = [
        {rightImageUrl: '/images/office_01.jpg', text: 'Styr på arbejdsmiljøet'},
        {rightImageUrl: '/images/office_02.jpg', text: 'Arbejdsmiljøet samlet ét sted'},
        {rightImageUrl: '/images/office_04.jpg', text: 'Jeres arbejdsmiljøplatform'}
    ];

    const selected = getRandomImageAndText();

    return (
        <CorePageWrapper activeUser={null} loading={false} hideMenu>
            <LoginLayout 
                leftBackgroundColor="#eeeeee" 
                rightImageUrl={selected.rightImageUrl}
                leftSide={
                    <Login />     
                }
                rightSide={
                    <LoginText>{selected.text}</LoginText>
                } />
        </CorePageWrapper>
    );
}


function Login():JSX.Element
{

    const [errorMessage, setErrorMessage] = useState<string>('');
    const [siteIdFromUrl, setSiteIdFromUrl] = useState('');
    const [siteId, setSiteId] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const params = useParams<{siteId:string}>();

    React.useEffect(()=>{
        setSiteIdFromUrl(params.siteId || '');
    },[params.siteId])
    

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        // ?fname=johnny&lname=depp
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        const returnUrl = urlParams.get('return');

        setErrorMessage('');
        
        const usedSiteId = siteIdFromUrl || siteId;

        const groomedSiteId = forgiveWhitespaceAndCase(usedSiteId);
        const groomedEmail = forgiveWhitespaceAndCase(email);

        const loginResult = await login(groomedSiteId, groomedEmail, password);
        if (loginResult.isSuccess) {
            if (returnUrl)
            {
                document.location.assign(returnUrl);
            }
            else
            {
                const { tokenUser } = await getMaybeActiveUserOrRefresh([]);
                if(tokenUser)
                    document.location.assign(appUrlBuilder.home.build(tokenUser));
            }
        }
        else
            setErrorMessage('Ugyldigt login - tjek dine oplysninger og prøv igen');
    }

    function handleSiteIdChange(value:string)
    {
        setSiteId(value);
    }

    function handleEmailChange(value:string)
    {
        setEmail(value);
    }

    function handlePasswordChange(value:string)
    {
        setPassword(value);
    }


    return (
        <form autoComplete="on" onSubmit={handleSubmit}>
            <CardLoginWrapper>
                <Flex flexDirection="column">
                    
                    <SpecialHeaderWrapper>
                        {/* <H1>Log ind</H1> */}
                        <AmorgBrand>
                        <img src="/images/amorg_logo_blue.svg" alt="AMORG Logo" width={32} height={24} />
                        AMORG
                    </AmorgBrand>
                    </SpecialHeaderWrapper>
                    <Flex flexDirection="column" gap={24}>
                        <CardLogin>
                            <Flex flexDirection="column" gap={16}>
                                {!siteIdFromUrl &&
                                <Flex flexDirection="column">
                                    <Label color={rawColors.white}>Organisation</Label>
                                    <TextField
                                        dataCy='site-input'
                                        value={siteId}
                                        onChange={handleSiteIdChange}
                                        autoComplete="on"
                                        placeholder="Organisation" 
                                        validator={() => { return {valid:true}}}                            
                                    />
                                </Flex>
                                }
                                <Flex flexDirection="column">
                                    <Label color={rawColors.white}>E-mail</Label>    
                                    <TextField
                                        dataCy="email-input"
                                        value={email}
                                        onChange={handleEmailChange}
                                        autoComplete="on"
                                        placeholder="E-mail" 
                                        validator={() => { return {valid:true}}}                            
                                    />
                                </Flex>
                                <Flex flexDirection='column'>
                                    <Label color={rawColors.white}>Adgangskode</Label>
                                    <TextField
                                        dataCy="pw-input"
                                        type="password"
                                        value={password}
                                        onChange={handlePasswordChange}
                                        autoComplete="on"
                                        placeholder="Adgangskode" 
                                        validator={() => { return {valid:true}}}                            
                                    />
                                                                            
                                    <ButtonRow variant={"centered"}>
                                        <Link 
                                            href="/request/resetpassword" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            colorSettings={{normal: rawColors.white, hover: rawColors.black}}
                                            >Glemt adgangskode ?</Link>
                                    </ButtonRow>
                                </Flex>                        
                                
                                <div>
                                    {errorMessage !== '' && (<MessageCard variant="error"><P>{errorMessage}</P></MessageCard>)}
                                </div>


                                <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
                                    <Button variant="filled"
                                        dataCy="submit"
                                        text={"Log ind"} />
                                </Flex>
                                    
                            </Flex>
                        </CardLogin>        
                    </Flex>
                </Flex>
            </CardLoginWrapper>
        </form>
    );
}